import {SHOW_NAVIGATION, HIDE_NAVIGATION} from './../actions/actionTypes';

export const showNavigation = () => {
    return function(dispatch) {
        dispatch({ type: SHOW_NAVIGATION, visibility: true });
    };
}

export const hideNavigation  = () => {
    return function(dispatch) {
        dispatch({ type: HIDE_NAVIGATION, visibility: false });
    };
}